import produce from "immer";
import {OperationErrorType, StoreAction} from "orpyx-web-common";
import {IOrganizationChannelDto} from "admins-dashboard/http-clients/index";
import {ChannelsActions} from "./channels-actions";

export interface ChannelsState {
    initialized: boolean;
    channels: IOrganizationChannelDto[];
    error?: OperationErrorType;
}

const initialState: ChannelsState = {
    initialized: false,
    channels: []
};

const ChannelsReducers = (state = initialState, action: StoreAction<ChannelsActions>): ChannelsState => {
    return produce(state, (draft: ChannelsState) => {
        switch (action.type) {
            case ChannelsActions.INITIALIZE:
                draft.initialized = false;
                draft.error = undefined;
                break;

            case ChannelsActions.INITIALIZE_SUCCESSFULLY:
                draft.initialized = true;
                draft.channels = action.payload;
                draft.error = undefined;
                break;

            case ChannelsActions.INITIALIZE_FAILED:
                draft.initialized = false;
                draft.error = action.payload;
                draft.channels = [];
                break;
        }
    })
};

export default ChannelsReducers;
